import { rechargeApiRequest } from '../utils/request.js';
async function getPaymentMethod(session, id, options) {
  const {
    payment_method
  } = await rechargeApiRequest("get", `/payment_methods`, {
    id,
    query: {
      include: options?.include
    }
  }, session);
  return payment_method;
}
async function createPaymentMethod(session, createRequest) {
  const {
    payment_method
  } = await rechargeApiRequest("post", `/payment_methods`, {
    data: {
      ...createRequest,
      customer_id: session.customerId
    }
  }, session);
  return payment_method;
}
async function updatePaymentMethod(session, id, updateRequest) {
  const {
    payment_method
  } = await rechargeApiRequest("put", `/payment_methods`, {
    id,
    data: updateRequest
  }, session);
  return payment_method;
}
function listPaymentMethods(session, query) {
  return rechargeApiRequest("get", `/payment_methods`, {
    query
  }, session);
}
export { createPaymentMethod, getPaymentMethod, listPaymentMethods, updatePaymentMethod };